import angular from 'angular';
import uiRouter from 'angular-ui-router';
import saveDialogComponent from './saveDialog.component';

let saveDialogModule = angular.module('saveDialog', [
  uiRouter
])

.component('saveDialog', saveDialogComponent)

.name;

export default saveDialogModule;



// WEBPACK FOOTER //
// ./client/app/common/saveDialog/saveDialog.js